import { Type } from "~/models/dto";
import type { Permissions } from "~/models/permissions";
import { identity } from "~/tools/identity";

import { useWebSocketStream } from "../components/_websocket";

export function usePermissions(): undefined | Permissions;
export function usePermissions<TResult>(select: (permissions: Permissions) => TResult): undefined | TResult;

export function usePermissions<TResult>(
	select: (permissions: Permissions) => TResult = identity as typeof select,
): undefined | TResult {
	const { data } = useWebSocketStream({
		request: {
			_type: Type.SubjectPermissionsRequest,
		},
		select,
	});

	return data;
}
